import React, { createContext, useCallback, useContext } from "react";

import { SETTINGS_KEYS } from "@/constants/settings-keys";
import { useRemoteConfigInput } from "@/pages/settings/utils/use-remote-config-input";

type GuidedTourContextValue = {
    run: boolean;
    restartTour: () => void;
    hasSeenTour: boolean;
    setHasSeenTour: (seen: boolean) => void;
};

const GuidedTourContext = createContext<GuidedTourContextValue | undefined>(undefined);

export const GuidedTourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { value: hasSeenTour, onChange: setHasSeenTour } = useRemoteConfigInput<boolean>(SETTINGS_KEYS.HAS_SEEN_TOUR);

    const restartTour = useCallback(() => {
        if (document.querySelector('[data-tour="brand-selector"]')) {
            setHasSeenTour(false);
            return;
        }
        const interval = setInterval(() => {
            if (document.querySelector('[data-tour="brand-selector"]')) {
                setHasSeenTour(false);
                clearInterval(interval);
            }
        }, 100);
    }, [setHasSeenTour]);

    return (
        <GuidedTourContext.Provider value={{ run: !hasSeenTour, restartTour, hasSeenTour, setHasSeenTour }}>
            {children}
        </GuidedTourContext.Provider>
    );
};

export const useGuidedTourContext = () => {
    const ctx = useContext(GuidedTourContext);
    if (!ctx) throw new Error("useGuidedTourContext must be used within a GuidedTourProvider");
    return ctx;
};
